import { render, staticRenderFns } from "./HrContractStructureCreate.vue?vue&type=template&id=2e20e13d&lang=pug&"
import script from "./HrContractStructureCreate.vue?vue&type=script&lang=js&"
export * from "./HrContractStructureCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HrContractStructureCreate.vue"
export default component.exports